import type { GeoJsonData, OnMapLoaded } from '../../../../app-kit/components/PcaMap/PcaMap';
import { trackFullscreenToggleOnce } from '../../../../analytics/event-tracking/map-tracking/trackFullscreenToggleOnce';
import { trackZoomLevelChangeOnce } from '../../../../analytics/event-tracking/map-tracking/trackZoomLevelChangeOnce';
import type { MapInteractionEventData } from '../../../../analytics/event-tracking/trackMapInteraction';
import { setStyles } from '../../../../app-kit/components/PcaMap/helpers/setStyles';
import { addPropertyMapGeoJson } from './addPropertyMapGeoJson';
import { fitPropertyMapByBounds } from './fitPropertyMapByBounds';
import { addControlButtonsToTopRight } from '../../../../app-kit/components/PcaMap/subcomponents/helpers/addControlButtonsToMap';
import { createRef } from 'react';
import type { DefaultTheme } from 'styled-components';

interface MapInteractionTracking {
  changeZoomLevel: MapInteractionEventData;
  toggleFullscreen: MapInteractionEventData;
}

export const onPropertyMapLoaded = ({
  tracking,
  propertyBoundary,
  buildingBoundaries,
  controlButtonsRef = createRef(),
  theme,
}: {
  tracking?: MapInteractionTracking | null;
  propertyBoundary?: GeoJsonData | null;
  buildingBoundaries?: GeoJsonData | null;
  controlButtonsRef?: React.MutableRefObject<HTMLDivElement | null>;
  theme: DefaultTheme;
}): OnMapLoaded => {
  return ({ google, map }) => {
    addPropertyMapGeoJson(map, propertyBoundary, buildingBoundaries);
    fitPropertyMapByBounds(map, propertyBoundary, buildingBoundaries);
    setStyles(map, theme);
    addControlButtonsToTopRight(map, controlButtonsRef);

    if (tracking) {
      google.maps.event.addListenerOnce(map, 'tilesloaded', () => {
        trackFullscreenToggleOnce(map, tracking.toggleFullscreen);
        trackZoomLevelChangeOnce(google, map, tracking.changeZoomLevel);
      });
    }
  };
};
